/**
*time: 2021/8/30
*/
<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="量表名称">
            <a-input v-decorator="['searchKey']" @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
              placeholder="量表名称" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="编辑时间">
            <a-range-picker style="width: 100%;" v-decorator="['createTime']" class="search_content_class"
              :locale="locale" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="有效期">
            <a-range-picker style="width: 100%;" v-decorator="['effective']" class="search_content_class"
              :locale="locale" />
          </a-form-item>
        </a-col>
        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" @click="getList({current:1,pageSize:pagination.pageSize})">
            查询
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <div class="content_class">
      <div style="padding: 20px 0 0 20px">
        <a-button type="primary" icon="plus" style="margin-right: 12px" @click="showAddFunc">
          新增
        </a-button>
        <a-button type="danger" ghost :disabled="selectedRowKeys.length === 0" @click="deleteList">
          删除
        </a-button>
      </div>
      <!-- 新增 -->
      <a-modal :visible="showAdd" :confirm-loading="false" @ok="addSubmit" @cancel="showAddFunc" cancelText='取消'
        okText='确定' :maskClosable='false' width='800px' destroyOnClose>
        <template #title>
          新增生产量表<span class="subTitle">根据有效期填充期间内销售月计划数据</span>
        </template>
        <EstimateAdd ref="add" />
      </a-modal>
      <!-- 编辑/复制 -->
      <a-modal :visible="showEdit" :confirm-loading="false"
        @ok="editSubmit" @cancel="showEditFunc" cancelText='取消' okText='确定' :maskClosable='false' width='800px'
        destroyOnClose>
        <template #title>
          {{ functionType === 'copy' ? '复制生产量表' : '编辑生产量表' }}<span class="subTitle">根据有效期填充期间内销售月计划数据</span>
        </template>
        <EstimateEdit ref="edit" :editObj='editObj' :functionType='functionType' />
      </a-modal>

      <a-table ref="listRef" :scroll="{y,x: 1000}" class="tableBox" :columns="columns" :data-source="list"
        :pagination="pagination" :locale="locale"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id">
        <div slot="effective" slot-scope="text,record">
          <span>{{record.effectiveStart ? record.effectiveStart.split(' ')[0] : ''}}</span>
          ~
          <span>{{record.effectiveEnd ? record.effectiveEnd.split(' ')[0] : ''}}</span>
        </div>
        <div slot="x" slot-scope="text,record">
          <a @click="showEditFunc('edit',record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="showEditFunc('copy',record)">复制</a>
          <a-divider type="vertical" />
          <a @click="manageList(record)">管理量表</a>
        </div>
      </a-table>

      <!-- :closable="false" -->
      <a-drawer title="预计生产量表" destroyOnClose placement="right" :visible="drawerVisible" @close="drawerClose"
        width='800' :locale="locale">
        <EstimateBox :drwaerObj='drwaerObj' />
      </a-drawer>
    </div>
  </div>
</template>
<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import EstimateAdd from './EsimateCompoent/EstimateAdd.vue'
import EstimateEdit from './EsimateCompoent/EstimateEdit.vue'
import EstimateBox from './EsimateCompoent/EstimateBox.vue'

import moment from 'moment'
const columns = [
  {
    title: '编号',
    dataIndex: 'code',
    width: 180
  },
  {
    title: '量表名称',
    dataIndex: 'name',
    width: 160
  },
  {
    title: '工厂名称',
    dataIndex: 'factoryName',
    width: 160
  },
  {
    title: '用户',
    dataIndex: 'userName',
    width: 120
  },
  {
    title: '有效期',
    dataIndex: 'effective',
    scopedSlots: { customRender: 'effective' },
    width: 200
  },
  {
    title: '编辑时间',
    dataIndex: 'updateTime',
    width: 180
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 300,
    scopedSlots: { customRender: 'x' },
  },
];
export default {
  components:{EstimateAdd,EstimateEdit,EstimateBox},
  data(){
    return{
      drwaerObj: {},
      listY: 500,
      functionType: 'edit',
      drawerVisible: false,
      editObj:{},
      showEdit:false,
      modalType:'',
      showAdd:false,
      selectedRowKeys:[],
      y: 500,
      form: this.$form.createForm(this, { name: 'OperationLog' }),
      locale,
      pagination: {
        total: 0,
        pageSize: 0,
        current: 1,
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.pagination.pageSize = pageSize
          this.getList()
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          window.localStorage.setItem('estimatePageSize',pageSize)
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns,
      list: []
    }
  },
  created(){
    this.getList()
  },
  computed:{
    pageSizeC(){
      let pageSize = window.localStorage.getItem('estimatePageSize')
      let pageSizeC = pageSize ? Number(pageSize) : 20
      return pageSizeC
    },
  },
  mounted(){
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  methods: {
    drawerClose(){
      this.drawerVisible = false
    },
    manageList(record){
      this.drwaerObj = record
      this.drawerVisible = true;
    },
    deleteList(){
      let ids = this.selectedRowKeys.join(',')
      this.$confirm({
        title: '删除预计生产量表',
        cancelText:'取消',
        okText:'确定',
        content: () => <div><span style="color:red;">量表删除后，所设置的所有数据都将删除，</span>你还要继续吗？</div>,
        onOk:() => {
          this.$http.post(`/nhf-app/productionforecast/remove?ids=${ids}`).then(res => {
            let {success} = res;
            if(this.selectedRowKeys.length >= this.list.length) {
              this.getList({current: 1,pageSize: this.pagination.pageSize})
            }else{
              this.getList({current: 1,pageSize: this.pagination.pageSize})
            }
            if(success){
              this.$message.success('删除成功')
              this.selectedRowKeys = []
            }else{
              this.$message.error('在多配方任务中应用的量表无法删除，请清理后再操作。')
            }
          })
        }
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    resetFields(){
      this.form.resetFields()
    },
    getList(pagination){
      let {current,pageSize} = pagination || this.pagination
      pageSize = pageSize ? pageSize : this.pageSizeC
      this.form.validateFields((err, values) => {
        let {createTime,effective,searchKey} = values || {}
        let params = {
          current,size: pageSize,searchKey,
          createTimeStart: createTime&&createTime.length ? moment(createTime[0]).format('YYYY-MM-DD 00:00:00'): undefined,
          createTimeEnd: createTime&&createTime.length ? moment(createTime[1]).format('YYYY-MM-DD 23:59:59'): undefined,
          effectiveStart: effective&&effective.length ? moment(effective[0]).format('YYYY-MM-DD 00:00:00'): undefined,
          effectiveEnd: effective&&effective.length ? moment(effective[1]).format('YYYY-MM-DD 23:59:59'): undefined,
          factoryId: window.localStorage.getItem('factoryId')
        }
        this.$http.get('/nhf-app/productionforecast/page',{params}).then(res => {
          let {success,data} = res;
          if(success){
            let {records,current=1,total=0,size} = data;
            this.pagination.current = current
            this.pagination.total = total
            this.list = records || []
            this.pagination.pageSize = size
          }else{
            this.$message.error('查询失败')
          }
        })
      })
    },
    addSubmit(){
      // 新增提交
      this.$refs['add'].form.validateFields((err, values) => {
        if(err){
          this.$message.error('请完善新增数据')
        }else{
          let {date,...newVal} = values
          let data ={
            factoryId: window.localStorage.getItem('factoryId'),
            effectiveStart: date&&date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00'): undefined,
            effectiveEnd: date&&date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
            ...newVal
          }
          this.$http.post('/nhf-app/productionforecast/save',data).then(res => {
            let {success} = res;
            if(success){
              this.$message.success('新增成功')
            }else{
              this.$message.error('新增失败')
            }
            this.getList()
            this.showAddFunc()
          })
        }
      })
    },
    showAddFunc(){
      // 新增显示或关闭
      this.showAdd = !this.showAdd
    },
    showEditFunc(type,editObj){
      // 编辑显示或关闭
      if(type === 'edtiBtn'){
        if(this.selectList.length > 1){
          this.$message.warning('编辑只能选中一条数据')
        }else if(this.selectList.length === 0){
          this.$message.warning('请选中需要编辑的数据')
        }else{
          this.showEdit = !this.showEdit
        }
      }else{
        if(typeof type === "string") this.functionType = type
        this.editObj = editObj
        this.showEdit = !this.showEdit
      }
    },
    editSubmit(){
      // 编辑提交
      let editObj = this.$refs['edit']
      editObj.form.validateFields((err, values) => {
        if(err){
          this.$message.error('请完善编辑数据')
        }else{
          let {date,...newVal} = values
          let data = Object.assign({},this.editObj,{
            effectiveStart: date&&date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00'): undefined,
            effectiveEnd: date&&date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
            ...newVal
          })
          let src = '/nhf-app/productionforecast/update'
          let msg = '修改'
          if(this.functionType === 'copy'){
            // delete data.id
            src = '/nhf-app/productionforecast/copy'
            msg = '复制'
          }
          this.$http.post(src,data).then(res => {
            let {success} = res;

            if(success){
              this.$message.success(`${msg}成功`)
            }else{
              this.$message.error(`${msg}失败`)
            }
            this.showEditFunc()
            this.getList()
          })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.listContent {
  height: calc(100% - 41px);
  border-radius: 5px;

  .title_class {
    background-color: #fff;
    margin-bottom: 21px;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .title_search_class {
      display: flex;
      flex-wrap: wrap;
      flex: 2;

      .search_change_class {
        display: flex;
        align-items: center;
        margin: 0 10px 10px 0;

        .text_class {
          width: 100px;
        }
      }
    }

    .title_btn_class {
      flex: 0.6;

      .search_class {
        margin-right: 10px;
      }
    }
  }

  .content_class {
    background-color: #fff;
    border-radius: 5px;
    // padding: 20px;
    height: calc(100% - 80px);
  }
}

.tableBox {
  height: calc(100% - 44px);
}

.subTitle {
  font-size: 12px;
  font-weight: normal;
  color: #999;
  margin-left: 2em;
}
</style>